// extracted by mini-css-extract-plugin
export var clickable = "TreeStamp-module--clickable--647d9";
export var detailContainer = "TreeStamp-module--detailContainer--041a9";
export var image = "TreeStamp-module--image--267bf";
export var link = "TreeStamp-module--link--82709";
export var listing = "TreeStamp-module--listing--a8899";
export var name = "TreeStamp-module--name--aae34";
export var overlay = "TreeStamp-module--overlay--f7ed2";
export var species = "TreeStamp-module--species--94b81";
export var stampContent = "TreeStamp-module--stampContent--be334";
export var treeStamp = "TreeStamp-module--treeStamp--4dd91";